import { Box, Grid, Modal, Paper, TextField, Typography } from '@mui/material';
import { ExtendedGridColDef } from '@/types/ExtendedGridColDef';
import React, { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Swal from 'sweetalert2';
import { SCUIButton, SCUIDateRanger } from '../../../../atomic/atoms';
import { SCUICustomDataGrid } from '../../../../atomic/molecules';
import { PaymentCommand } from '../../../../services/command';
import TimeHelper from '../../../../utils/time';
import IconButton from '@mui/material/IconButton';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import CloseIcon from '@mui/icons-material/Close';
import { useLocation } from 'react-router-dom';
import { CPL, cplCls } from './customerPaymentLogs.classes';

interface IProps {
    data?: any;
}
export const CustomerPaymentLogs: FC<IProps> = ({ data }) => {
    const { t } = useTranslation();
    const [datas, setDatas] = React.useState<any>();
    const [startDate, setStartDate] = React.useState<any>();
    const [endDate, setEndDate] = React.useState<any>();
    const [isModalOpen, setModalOpen] = React.useState<boolean>(false);
    const [step, setStep] = React.useState(0);
    const query = new URLSearchParams(useLocation().search);
    const orderNumberFromUrl = query.get('orderNumber');
    const customerIdFromUrl = query.get('customerId');
    const [shippingNo, setShippingNo] = React.useState<any>(orderNumberFromUrl && orderNumberFromUrl);
    const customerId = customerIdFromUrl ? customerIdFromUrl : data?.customer?.customerId;
    const _handlChangeDate = (event: any) => {
        const formattedDateString = event[0].replace(/-/g, '/');
        const formattedDateString1 = event[1].replace(/-/g, '/');

        const dateObject = new Date(formattedDateString);
        const dateObject1 = new Date(formattedDateString1);

        const timestamp = dateObject.getTime();
        const timestamp1 = dateObject1.getTime();

        const differenceInTime: any = timestamp1 - timestamp;
        const differenceInDays = differenceInTime / (1000 * 3600 * 24);

        if (differenceInDays > 7) {
            setStartDate(null);
            setEndDate(null);
            Swal.fire(t('customerInformation.differentDaysMessage'), '', 'error');
            //   setStartDate("");
            //  setEndDate("");
            return;
        } else {
            setStartDate(event[0]);
            setEndDate(event[1]);
        }
    };
    useEffect(() => {
        if (customerId && shippingNo) {
            GetCustomerPaymentLogs();
        }
    }, [orderNumberFromUrl, customerIdFromUrl]);
    const GetCustomerPaymentLogs = async () => {
        if (startDate == '' && endDate == '' && shippingNo == '') {
            Swal.fire(t('general.error'), t('customerInformation.enterInput'), 'error');
            return;
        }
        let params = {
            customerId: customerIdFromUrl ? customerIdFromUrl : data.customer.customerId,
            orderNumber: orderNumberFromUrl ? orderNumberFromUrl : shippingNo === '' ? null : shippingNo,
            startDate: startDate,
            endDate: endDate,
        };
        PaymentCommand.GetCustomerPaymentRequestList(params).then((res: any) => {
            if (!res?.customerPaymentRequestModels) {
                Swal.fire(t('general.error'), t('customerInformation.customerNoRecordFound'), 'error');
                return;
            }
            let parseData = res.customerPaymentRequestModels.map((item: any, index: any) => {
                return {
                    index: index,
                    id: item.requestId,
                    orderNumber: item.orderNumber,
                    status: item.status,
                    posMachineProviderCompanyName: item.posMachineProviderCompanyName,
                    requestDateTime: TimeHelper.formatDateHour(item.requestDateTime),
                    responseDateTime: TimeHelper.formatDateHour(item.responseDateTime),
                    responseData: item.responseData,
                    description: item.description || '-',
                    requestData: item.requestData,
                };
            });
            setDatas(parseData);
        });
    };
    const columns: ExtendedGridColDef[] = [
        { field: 'id', headerName: 'Id', flex: 1 },
        { field: 'requestDateTime', headerName: t('general.date'), flex: 1 },
        { field: 'description', headerName: t('general.description'), flex: 1 },
        { field: 'requestData', headerName: t('general.posSentData'), flex: 1 },
        {
            field: 'responseData',
            headerName: t('general.posReceivedData'),
            flex: 1,
            renderCell: (params: any) => {
                const handleModalOpen = () => {
                    setModalOpen(true);
                };

                const handleModalClose = () => {
                    setModalOpen(false);
                };
                function prettyPrint(data: any) {
                    try {
                        const jsonData = JSON.parse(data);
                        return JSON.stringify(jsonData, null, 2);
                    } catch {
                        return data;
                    }
                }
                const nexItem = (step?: any, array?: any) => {
                    if (step > -1 && step < array.length) {
                        if (step === -1) {
                            setStep(0);
                            handleModalClose();
                        } else return array[step]?.responseData;
                    } else {
                        setStep(0);
                        handleModalClose();
                    }
                };
                return (
                    <>
                        <p
                            className={cplCls('linktxt', CPL.inputLinkResponseData)}
                            onClick={() => {
                                handleModalOpen();
                                setStep(params.row.index);
                            }}
                            style={{
                                cursor: 'pointer',
                                color: '#1976d2',
                                fontWeight: 500,
                                textDecoration: 'underline',
                                textDecorationColor: 'transparent',
                                transition: 'text-decoration-color 0.15s ease',
                            }}
                            onMouseEnter={(e) => ((e.target as HTMLElement).style.textDecorationColor = '#1976d2')}
                            onMouseLeave={(e) => ((e.target as HTMLElement).style.textDecorationColor = 'transparent')}
                        >
                            {params.row.responseData}
                        </p>

                        <Modal
                            className={CPL.modal}
                            open={isModalOpen}
                            slotProps={{
                                backdrop: {
                                    style: { backgroundColor: 'transparent' },
                                },
                            }}
                            onClose={() => {
                                handleModalClose();
                                setStep(0);
                            }}
                        >
                            <>
                                <Box
                                    className={CPL.modalContent}
                                    sx={{
                                        position: 'absolute',
                                        top: '50%',
                                        left: '50%',
                                        transform: 'translate(-50%, -50%)',
                                        width: '50%',
                                        height: '90%',
                                        overflowY: 'auto',
                                        p: 3,
                                        backgroundColor: '#ffffff',
                                        borderRadius: '16px',
                                        boxShadow: '0 8px 40px rgba(0,0,0,0.18)',
                                        border: '1px solid #e0e7ef',
                                        outline: 'none',
                                    }}
                                >
                                    <Box
                                        className={CPL.modalHeader}
                                        display="flex"
                                        justifyContent="space-between"
                                        alignItems="center"
                                        mb={2}
                                    >
                                        <Typography variant="subtitle1" fontWeight={700} color="text.primary">
                                            Request Id:{' '}
                                            <Typography
                                                component="span"
                                                variant="subtitle1"
                                                color="primary.main"
                                                fontWeight={700}
                                            >
                                                {step >= 0 ? datas[step].id : ''}
                                            </Typography>
                                        </Typography>
                                        <IconButton
                                            className={CPL.inputIconButtonModalClose}
                                            onClick={handleModalClose}
                                            size="small"
                                            sx={{
                                                border: '1px solid #e0e0e0',
                                                borderRadius: '8px',
                                                color: '#546e7a',
                                                transition: 'all 0.18s ease',
                                                '&:hover': {
                                                    backgroundColor: '#ffebee',
                                                    borderColor: '#ef9a9a',
                                                    color: '#c62828',
                                                },
                                            }}
                                        >
                                            <CloseIcon sx={{ fontSize: 18 }} />
                                        </IconButton>
                                    </Box>

                                    <pre className={cplCls('jsonViewDiv', CPL.jsonPre)}>
                                        {prettyPrint(nexItem(step, datas))}
                                    </pre>

                                    <Grid
                                        className={CPL.modalNavRow}
                                        container
                                        justifyContent="space-between"
                                        sx={{ mt: 2 }}
                                    >
                                        <IconButton
                                            className={CPL.inputIconButtonModalPrev}
                                            onClick={() => setStep(step - 1)}
                                            sx={{
                                                color: '#1976d2',
                                                border: '1px solid #bbdefb',
                                                borderRadius: '8px',
                                                px: 2,
                                                gap: 0.5,
                                                fontSize: '0.85rem',
                                                fontWeight: 600,
                                                '&:hover': { backgroundColor: '#e3f2fd' },
                                            }}
                                        >
                                            <ArrowBackIosIcon sx={{ fontSize: 14 }} /> Önceki
                                        </IconButton>
                                        <IconButton
                                            className={CPL.inputIconButtonModalNext}
                                            onClick={() => setStep(step + 1)}
                                            sx={{
                                                color: '#1976d2',
                                                border: '1px solid #bbdefb',
                                                borderRadius: '8px',
                                                px: 2,
                                                gap: 0.5,
                                                fontSize: '0.85rem',
                                                fontWeight: 600,
                                                '&:hover': { backgroundColor: '#e3f2fd' },
                                            }}
                                        >
                                            Sonraki <ArrowForwardIosIcon sx={{ fontSize: 14 }} />
                                        </IconButton>
                                    </Grid>
                                </Box>
                            </>
                        </Modal>
                    </>
                );
            },
        },
        { field: 'responseDateTime', headerName: t('general.responseDateTime'), flex: 1 },
        { field: 'status', headerName: t('general.status'), flex: 1 },
        {
            field: 'posMachineProviderCompanyName',
            headerName: t('general.posMachine'),
            flex: 1,
        },
    ];
    return (
        <Grid
            className={CPL.page}
            container
            size={{
                xl: 12,
                lg: 12,
                md: 12,
                xs: 12,
            }}
            spacing={2}
        >
            <Grid
                size={{
                    xl: 12,
                    lg: 12,
                    md: 12,
                    xs: 12,
                }}
            >
                <Paper
                    className={CPL.paperFilters}
                    elevation={0}
                    sx={{
                        px: 3,
                        py: 2.5,
                        borderRadius: '14px',
                        border: '1px solid #e0e7ef',
                        boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
                        backgroundColor: '#f8fafd',
                    }}
                >
                    <Typography
                        className={CPL.sectionTitle}
                        variant="caption"
                        sx={{
                            display: 'block',
                            mb: 1.5,
                            fontWeight: 600,
                            color: '#78909c',
                            letterSpacing: 0.4,
                            textTransform: 'uppercase',
                            fontSize: '0.7rem',
                        }}
                    >
                        {t('customerInformation.customerPaymentLogs')}
                    </Typography>
                    <Grid className={CPL.filtersRow} container spacing={2} alignItems="center">
                        <Grid
                            size={{
                                xl: 4,
                                lg: 4,
                                md: 12,
                                xs: 12,
                            }}
                        >
                            <TextField
                                className={CPL.inputTextfieldOrderNo}
                                id="outlined-required"
                                label={t('general.orderNo')}
                                value={shippingNo}
                                size="small"
                                fullWidth
                                onChange={(event: any) => {
                                    setShippingNo(event.target.value);
                                }}
                                sx={{ '& .MuiOutlinedInput-root': { borderRadius: '8px' }, height: '35px' }}
                            />
                        </Grid>
                        <Grid
                            size={{
                                xl: 4,
                                lg: 4,
                                md: 12,
                                xs: 12,
                            }}
                        >
                            <Box className={CPL.fieldDateRange}>
                                <SCUIDateRanger setDateRange={_handlChangeDate} dateFormat="YYYY-MM-DD" />
                            </Box>
                        </Grid>
                        <Grid
                            sx={{ display: 'flex', alignItems: 'center' }}
                            size={{
                                xl: 4,
                                lg: 4,
                                md: 12,
                                xs: 12,
                            }}
                        >
                            <SCUIButton
                                className={CPL.inputButtonSearch}
                                text={t('general.search')}
                                type="primary"
                                style={{ height: '35px' }}
                                sizeType="fixed"
                                buttonType="submit"
                                size={'m'}
                                onClick={GetCustomerPaymentLogs}
                            />
                        </Grid>
                    </Grid>
                    <Typography
                        className={CPL.fieldHelperText}
                        variant="caption"
                        sx={{
                            display: 'block',
                            mt: 1.5,
                            color: '#90a4ae',
                            fontStyle: 'italic',
                            fontWeight: 500,
                            fontSize: '0.75rem',
                        }}
                    >
                        {t('customerInformation.paymentMethodHelperText')}
                    </Typography>
                </Paper>
            </Grid>

            {datas && (
                <Grid
                    size={{
                        xl: 12,
                        lg: 12,
                        md: 12,
                        xs: 12,
                    }}
                >
                    <Paper
                        className={CPL.paperResults}
                        elevation={0}
                        sx={{
                            borderRadius: '14px',
                            border: '1px solid #e0e7ef',
                            boxShadow: '0 2px 12px rgba(0,0,0,0.07)',
                            overflow: 'hidden',
                            padding: '16px',
                        }}
                    >
                        <Box className={CPL.datagrid}>
                            <SCUICustomDataGrid randomId rows={datas} columns={columns} />
                        </Box>
                    </Paper>
                </Grid>
            )}
        </Grid>
    );
};
